// Third-party
import React from 'react';
import classNames from 'classnames';

interface Props {
  className?: string;
}

const Divider = ({ className }: Props) => <span className={classNames('divider', className)} />;

export default Divider;
